module.exports = __webpack_public_path__ + "static/media/search-icon.a55bb5f1.svg";